/**
 * Comm Tower Ridge — baked by ultra_map_editor. Edit via the editor.
 *
 * Do not hand-edit: this file is regenerated wholesale on the next bake, and
 * hand-written comments/formatting do not survive a bake.
 */
import type { WorldData } from '../../types';

export const map: WorldData = {
  cityName: "Comm Tower Ridge",
  ground: { width: 76, depth: 80 },
  spawnPoint: { x: 2, z: 34 },
  groundTexture: { textureUrl: "/textures/ground-realistic.webp", textureScale: 0.16, textureRotation: 0, secondaryUrl: "/textures/ground-stylized.webp", secondaryScale: 0.11, secondaryRotation: 0.82, noiseUrl: "/textures/noise-detailed.webp", noiseScale: 0.05, noiseRotation: -0.4, noiseOffset: -0.06, noiseGain: 0.9 },

  objects: [
    {
      id: "ct-tower-1",
      kind: "building",
      label: "Guard Tower",
      position: { x: -4, z: -22 },
      size: { w: 4.891, d: 4.891, h: 7.4 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_guard_tower_1.glb",
      rotationY: 0,
    },
    {
      id: "ct-tower-2",
      kind: "building",
      label: "Relay Tower",
      position: { x: 18, z: -12 },
      size: { w: 4.394, d: 4.688, h: 7 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_guard_tower_2.glb",
      rotationY: 0.8,
    },
    {
      id: "ct-hut",
      kind: "building",
      label: "Relay Hut",
      position: { x: -18, z: -6 },
      size: { w: 5.601, d: 4.59, h: 3.2 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_b.glb",
      rotationY: -0.5,
    },
    {
      id: "ct-church",
      kind: "building",
      label: "Ridge Chapel",
      position: { x: 20, z: 18 },
      size: { w: 8.134, d: 7.633, h: 7.8 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_church.glb",
      rotationY: 2.6,
    },
    {
      id: "ct-gen",
      kind: "prop",
      label: "Relay Generator",
      position: { x: -6, z: -14 },
      size: { w: 2.4, d: 2.183, h: 2.142 },
      color: 0x6a5c4a,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:ct-gen",
      modelUrl: "/models/objects/obj_generator-diesel.glb",
      rotationY: 0.3,
    },
    {
      id: "ct-post",
      kind: "prop",
      label: "Leaning Mast",
      position: { x: -26, z: 16 },
      size: { w: 1.86, d: 2.588, h: 5.4 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 0,
    },
    {
      id: "comm_tower_ridge-row1-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -23.623, z: -22.139 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 3.56,
    },
    {
      id: "comm_tower_ridge-row1-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -18.441, z: -24.01 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 3.577,
    },
    {
      id: "comm_tower_ridge-row2-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 25.18, z: -22.156 },
      size: { w: 4.3, d: 1.834, h: 1.414 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.3,
      collisionD: 1.834,
      rotationY: 3.617,
    },
    {
      id: "comm_tower_ridge-row2-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 26.42, z: -19.481 },
      size: { w: 4.3, d: 1.821, h: 1.397 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.3,
      collisionD: 1.821,
      rotationY: 3.686,
    },
    {
      id: "comm_tower_ridge-row2-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 28.243, z: -17.139 },
      size: { w: 1.838, d: 4.3, h: 1.321 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.838,
      collisionD: 4.3,
      rotationY: 2.156,
    },
    {
      id: "comm_tower_ridge-row2-4",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 29.72, z: -14.599 },
      size: { w: 1.817, d: 4.3, h: 1.376 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      collisionW: 1.817,
      collisionD: 4.3,
      rotationY: 2.017,
    },
    {
      id: "comm_tower_ridge-row2-5",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 30.67, z: -11.758 },
      size: { w: 4.3, d: 1.792, h: 1.351 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-41.glb",
      collisionW: 4.3,
      collisionD: 1.792,
      rotationY: 3.682,
    },
    {
      id: "loot-1",
      kind: "loot",
      label: "Supply Crate",
      position: { x: 12.477, z: 9.212 },
      size: { w: 1.228, d: 1.228, h: 1.017 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:cache-1",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 4.632,
    },
    {
      id: "loot-2",
      kind: "loot",
      label: "Stacked Crates",
      position: { x: -16.6241, z: -1.4472 },
      size: { w: 1.448, d: 1.379, h: 0.796 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:cache-2",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.532,
    },
    {
      id: "loot-3",
      kind: "loot",
      label: "Ammo Case",
      position: { x: 3.834, z: -28.905 },
      size: { w: 1.146, d: 1.045, h: 0.683 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:cache-3",
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 3.529,
    },
    {
      id: "loot-4",
      kind: "loot",
      label: "Dumped Barrel",
      position: { x: -11.891, z: -4.218 },
      size: { w: 0.99, d: 0.99, h: 1.329 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:cache-4",
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.846,
    },
    {
      id: "loot-5",
      kind: "loot",
      label: "Toolbox",
      position: { x: 0.874, z: -12.505 },
      size: { w: 0.679, d: 0.578, h: 0.535 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:cache-5",
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 4.178,
    },
    {
      id: "loot-6",
      kind: "loot",
      label: "Supply Crate",
      position: { x: 3.257, z: -11.772 },
      size: { w: 1.147, d: 1.147, h: 0.951 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:cache-6",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 4.89,
    },
    {
      id: "loot-7",
      kind: "loot",
      label: "Stacked Crates",
      position: { x: 2.418, z: -26.407 },
      size: { w: 1.437, d: 1.369, h: 0.79 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:cache-7",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 0.119,
    },
    {
      id: "loot-8",
      kind: "loot",
      label: "Ammo Case",
      position: { x: 14.036, z: -7.09 },
      size: { w: 1.312, d: 1.197, h: 0.783 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:cache-8",
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 0.858,
    },
    {
      id: "loot-9",
      kind: "loot",
      label: "Dumped Barrel",
      position: { x: -2.109, z: -13.395 },
      size: { w: 1.003, d: 1.003, h: 1.346 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:cache-9",
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.887,
    },
    {
      id: "loot-10",
      kind: "loot",
      label: "Toolbox",
      position: { x: 13.0834, z: 16.2653 },
      size: { w: 0.71, d: 0.604, h: 0.559 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_comm_tower_ridge:cache-10",
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 5.075,
    },
    {
      id: "comm_tower_ridge-junk-1",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 27.667, z: 14.959 },
      size: { w: 7.14, d: 2.822, h: 3.003 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      rotationY: 3.091,
    },
    {
      id: "comm_tower_ridge-junk-2",
      kind: "prop",
      label: "Stump",
      position: { x: 13.523, z: 29.164 },
      size: { w: 0.756, d: 0.737, h: 0.828 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.487,
    },
    {
      id: "comm_tower_ridge-junk-3",
      kind: "prop",
      label: "Stump",
      position: { x: -17.92, z: -17.276 },
      size: { w: 0.699, d: 0.682, h: 0.765 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.7,
    },
    {
      id: "comm_tower_ridge-junk-4",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -12.99, z: 25.265 },
      size: { w: 6.399, d: 2.529, h: 2.691 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      rotationY: 3.633,
    },
    {
      id: "comm_tower_ridge-junk-5",
      kind: "prop",
      label: "Sandbags",
      position: { x: -5.425, z: 17.536 },
      size: { w: 1.659, d: 0.241, h: 0.226 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.089,
    },
    {
      id: "comm_tower_ridge-junk-6",
      kind: "prop",
      label: "Sandbags",
      position: { x: 13.625, z: -22.41 },
      size: { w: 1.816, d: 0.263, h: 0.247 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.944,
    },
    {
      id: "comm_tower_ridge-junk-7",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -29.061, z: -6.489 },
      size: { w: 8.19, d: 3.237, h: 3.445 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      rotationY: 0.683,
    },
    {
      id: "comm_tower_ridge-junk-8",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -18.259, z: 23.101 },
      size: { w: 0.601, d: 0.758, h: 0.863 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 4.58,
    },
    {
      id: "comm_tower_ridge-junk-9",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -5.496, z: -5.013 },
      size: { w: 0.711, d: 0.897, h: 1.021 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 6.169,
    },
    {
      id: "comm_tower_ridge-junk-10",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 7.645, z: 22.553 },
      size: { w: 2.531, d: 0.127, h: 2.418 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 3.402,
    },
    {
      id: "comm_tower_ridge-junk-11",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 11.236, z: 23.636 },
      size: { w: 0.641, d: 0.809, h: 0.921 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.366,
    },
    {
      id: "comm_tower_ridge-junk-12",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 8.873, z: -10.111 },
      size: { w: 2.301, d: 2.078, h: 0.974 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.946,
    },
    {
      id: "comm_tower_ridge-junk-13",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -20.063, z: -19.869 },
      size: { w: 1.835, d: 1.658, h: 0.777 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.636,
    },
    {
      id: "comm_tower_ridge-junk-14",
      kind: "prop",
      label: "Sandbags",
      position: { x: -10.313, z: 17.926 },
      size: { w: 1.722, d: 0.25, h: 0.235 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 5.927,
    },
    {
      id: "comm_tower_ridge-junk-15",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -16.848, z: 10.649 },
      size: { w: 0.696, d: 0.878, h: 0.999 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 3.122,
    },
    {
      id: "comm_tower_ridge-junk-16",
      kind: "prop",
      label: "Barrel",
      position: { x: -22.22, z: 19.637 },
      size: { w: 0.808, d: 0.808, h: 1.085 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.946,
    },
    {
      id: "comm_tower_ridge-junk-17",
      kind: "prop",
      label: "Stump",
      position: { x: -19.482, z: -10.764 },
      size: { w: 0.605, d: 0.59, h: 0.663 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.007,
    },
    {
      id: "comm_tower_ridge-junk-18",
      kind: "prop",
      label: "Tarp",
      position: { x: 5.394, z: -5.204 },
      size: { w: 1.376, d: 1.183, h: 0.408 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.506,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-19",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -16.283, z: 20.653 },
      size: { w: 1.959, d: 1.77, h: 0.83 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.979,
    },
    {
      id: "comm_tower_ridge-junk-20",
      kind: "prop",
      label: "Utility Post",
      position: { x: 18.918, z: -8.571 },
      size: { w: 1.484, d: 2.065, h: 4.309 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 5.681,
    },
    {
      id: "comm_tower_ridge-junk-21",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -23.888, z: -14.308 },
      size: { w: 2.614, d: 0.131, h: 2.497 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 0.985,
    },
    {
      id: "comm_tower_ridge-junk-22",
      kind: "prop",
      label: "Stump",
      position: { x: -4.543, z: 25.446 },
      size: { w: 0.735, d: 0.717, h: 0.805 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.038,
    },
    {
      id: "comm_tower_ridge-junk-23",
      kind: "prop",
      label: "Tarp",
      position: { x: -15.321, z: 2.057 },
      size: { w: 1.243, d: 1.069, h: 0.369 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.056,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-24",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 14.646, z: -14.356 },
      size: { w: 0.751, d: 0.949, h: 1.079 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0.341,
    },
    {
      id: "comm_tower_ridge-junk-25",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -12.769, z: -29.75 },
      size: { w: 6.13, d: 3.639, h: 3.711 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 0.018,
    },
    {
      id: "comm_tower_ridge-junk-26",
      kind: "prop",
      label: "Barrel",
      position: { x: 28.302, z: -2.53 },
      size: { w: 0.64, d: 0.64, h: 0.86 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.167,
    },
    {
      id: "comm_tower_ridge-junk-27",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 5.533, z: -23.958 },
      size: { w: 1.889, d: 1.707, h: 0.8 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.261,
    },
    {
      id: "comm_tower_ridge-junk-28",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 19.886, z: 25.709 },
      size: { w: 4.84, d: 2.873, h: 2.929 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 0.332,
    },
    {
      id: "comm_tower_ridge-junk-29",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 18.206, z: 8.587 },
      size: { w: 2.008, d: 1.814, h: 0.851 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.448,
    },
    {
      id: "comm_tower_ridge-junk-30",
      kind: "prop",
      label: "Utility Post",
      position: { x: 6.629, z: 16.645 },
      size: { w: 1.577, d: 2.194, h: 4.579 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 4.619,
    },
    {
      id: "comm_tower_ridge-junk-31",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 20.278, z: -19.859 },
      size: { w: 5.465, d: 3.244, h: 3.308 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 1.27,
    },
    {
      id: "comm_tower_ridge-junk-32",
      kind: "prop",
      label: "Barrel",
      position: { x: -9.917, z: 29.838 },
      size: { w: 0.815, d: 0.815, h: 1.094 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.24,
    },
    {
      id: "comm_tower_ridge-junk-33",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 1.885, z: -14.695 },
      size: { w: 2.284, d: 2.063, h: 0.967 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.207,
    },
    {
      id: "comm_tower_ridge-junk-34",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -12.51, z: -8.131 },
      size: { w: 2.222, d: 2.007, h: 0.941 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.507,
    },
    {
      id: "comm_tower_ridge-junk-35",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 13.964, z: -16.977 },
      size: { w: 0.584, d: 0.737, h: 0.839 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.195,
    },
    {
      id: "comm_tower_ridge-junk-36",
      kind: "prop",
      label: "Barrel",
      position: { x: 25.625, z: -4.827 },
      size: { w: 0.614, d: 0.614, h: 0.824 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.356,
    },
    {
      id: "comm_tower_ridge-junk-37",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 6.271, z: -31.547 },
      size: { w: 2.814, d: 0.141, h: 2.688 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 4.182,
    },
    {
      id: "comm_tower_ridge-junk-38",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 6.302, z: -11.224 },
      size: { w: 1.902, d: 1.718, h: 0.805 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.448,
    },
    {
      id: "comm_tower_ridge-junk-39",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -10.005, z: 11.692 },
      size: { w: 2.873, d: 0.144, h: 2.744 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 1.654,
    },
    {
      id: "comm_tower_ridge-junk-40",
      kind: "prop",
      label: "Barrel",
      position: { x: -7.56, z: -24.476 },
      size: { w: 0.829, d: 0.829, h: 1.113 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.466,
    },
    {
      id: "comm_tower_ridge-junk-41",
      kind: "prop",
      label: "Barrel",
      position: { x: 23.095, z: -4.432 },
      size: { w: 0.728, d: 0.728, h: 0.977 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.519,
    },
    {
      id: "comm_tower_ridge-junk-42",
      kind: "prop",
      label: "Barrel",
      position: { x: -8.552, z: -30.586 },
      size: { w: 0.652, d: 0.652, h: 0.875 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.8,
    },
    {
      id: "comm_tower_ridge-junk-43",
      kind: "prop",
      label: "Utility Post",
      position: { x: 14.297, z: 16.726 },
      size: { w: 1.289, d: 1.794, h: 3.743 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 5.339,
    },
    {
      id: "comm_tower_ridge-junk-44",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 15.998, z: 11.344 },
      size: { w: 2.59, d: 0.13, h: 2.474 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 0.861,
    },
    {
      id: "comm_tower_ridge-junk-45",
      kind: "prop",
      label: "Stump",
      position: { x: 21.346, z: 11.39 },
      size: { w: 0.861, d: 0.84, h: 0.943 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.818,
    },
    {
      id: "comm_tower_ridge-junk-46",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -32.408, z: 3.466 },
      size: { w: 2.087, d: 1.885, h: 0.884 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.376,
    },
    {
      id: "comm_tower_ridge-junk-47",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -7.216, z: 26.821 },
      size: { w: 4.651, d: 2.761, h: 2.815 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 1.538,
    },
    {
      id: "comm_tower_ridge-junk-48",
      kind: "prop",
      label: "Sandbags",
      position: { x: -18.16, z: -19.159 },
      size: { w: 1.774, d: 0.257, h: 0.242 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.558,
    },
    {
      id: "comm_tower_ridge-junk-49",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -11.688, z: -1.078 },
      size: { w: 2.349, d: 0.117, h: 2.243 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 4.068,
    },
    {
      id: "comm_tower_ridge-junk-50",
      kind: "prop",
      label: "Sandbags",
      position: { x: 13.177, z: -13.858 },
      size: { w: 1.843, d: 0.267, h: 0.251 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.479,
    },
    {
      id: "comm_tower_ridge-junk-51",
      kind: "prop",
      label: "Stump",
      position: { x: -8.197, z: 9.55 },
      size: { w: 0.771, d: 0.752, h: 0.844 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.683,
    },
    {
      id: "comm_tower_ridge-junk-52",
      kind: "prop",
      label: "Barrel",
      position: { x: -13.326, z: -4.37 },
      size: { w: 0.629, d: 0.629, h: 0.844 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.425,
    },
    {
      id: "comm_tower_ridge-junk-53",
      kind: "prop",
      label: "Stump",
      position: { x: -8.899, z: -8.02 },
      size: { w: 0.7, d: 0.683, h: 0.767 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 6.05,
    },
    {
      id: "comm_tower_ridge-junk-54",
      kind: "prop",
      label: "Tarp",
      position: { x: -9.547, z: -22.099 },
      size: { w: 1.478, d: 1.271, h: 0.439 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.734,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-55",
      kind: "prop",
      label: "Stump",
      position: { x: -28.639, z: -14.101 },
      size: { w: 0.791, d: 0.772, h: 0.867 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.088,
    },
    {
      id: "comm_tower_ridge-junk-56",
      kind: "prop",
      label: "Utility Post",
      position: { x: 13.056, z: 24.856 },
      size: { w: 1.654, d: 2.302, h: 4.803 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 2.988,
    },
    {
      id: "comm_tower_ridge-junk-57",
      kind: "prop",
      label: "Sandbags",
      position: { x: -24.821, z: 4.038 },
      size: { w: 1.628, d: 0.236, h: 0.222 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.544,
    },
    {
      id: "comm_tower_ridge-junk-58",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 9.776, z: -5.425 },
      size: { w: 2.428, d: 2.193, h: 1.028 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.387,
    },
    {
      id: "comm_tower_ridge-junk-59",
      kind: "prop",
      label: "Utility Post",
      position: { x: -6.717, z: 11.293 },
      size: { w: 1.27, d: 1.767, h: 3.688 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 5.51,
    },
    {
      id: "comm_tower_ridge-junk-60",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -12.707, z: -21.194 },
      size: { w: 2.209, d: 0.11, h: 2.11 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 1.781,
    },
    {
      id: "comm_tower_ridge-junk-61",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 1.632, z: -31.66 },
      size: { w: 0.709, d: 0.894, h: 1.018 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 5.005,
    },
    {
      id: "comm_tower_ridge-junk-62",
      kind: "prop",
      label: "Stump",
      position: { x: -4.529, z: 19.965 },
      size: { w: 0.711, d: 0.694, h: 0.779 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.582,
    },
    {
      id: "comm_tower_ridge-junk-63",
      kind: "prop",
      label: "Barrel",
      position: { x: 8.96, z: 16.073 },
      size: { w: 0.745, d: 0.745, h: 1.001 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.006,
    },
    {
      id: "comm_tower_ridge-junk-64",
      kind: "prop",
      label: "Sandbags",
      position: { x: 9.737, z: -16.903 },
      size: { w: 1.936, d: 0.281, h: 0.264 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.915,
    },
    {
      id: "comm_tower_ridge-junk-65",
      kind: "prop",
      label: "Utility Post",
      position: { x: -6.152, z: -7.714 },
      size: { w: 1.696, d: 2.36, h: 4.924 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 6.234,
    },
    {
      id: "comm_tower_ridge-junk-66",
      kind: "prop",
      label: "Stump",
      position: { x: -13.06, z: 17.802 },
      size: { w: 0.65, d: 0.634, h: 0.712 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.515,
    },
    {
      id: "comm_tower_ridge-junk-67",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 15.034, z: 8.016 },
      size: { w: 2.67, d: 0.133, h: 2.55 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 3.145,
    },
    {
      id: "comm_tower_ridge-junk-68",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 10.369, z: -13.198 },
      size: { w: 2.146, d: 1.939, h: 0.909 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.659,
    },
    {
      id: "comm_tower_ridge-junk-69",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -8.862, z: -28.943 },
      size: { w: 0.805, d: 1.016, h: 1.156 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.207,
    },
    {
      id: "comm_tower_ridge-junk-71",
      kind: "prop",
      label: "Stump",
      position: { x: 4.43, z: -9.053 },
      size: { w: 0.606, d: 0.591, h: 0.663 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.775,
    },
    {
      id: "comm_tower_ridge-junk-72",
      kind: "prop",
      label: "Barrel",
      position: { x: 13.724, z: -0.597 },
      size: { w: 0.775, d: 0.775, h: 1.04 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.385,
    },
    {
      id: "comm_tower_ridge-junk-73",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -28.767, z: -0.689 },
      size: { w: 2.212, d: 1.998, h: 0.937 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.005,
    },
    {
      id: "comm_tower_ridge-junk-74",
      kind: "prop",
      label: "Barrel",
      position: { x: 9.544, z: 11.18 },
      size: { w: 0.595, d: 0.595, h: 0.798 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.086,
    },
    {
      id: "comm_tower_ridge-junk-75",
      kind: "prop",
      label: "Tarp",
      position: { x: -9.458, z: 0.462 },
      size: { w: 1.257, d: 1.081, h: 0.373 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.415,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-76",
      kind: "prop",
      label: "Tarp",
      position: { x: -6.006, z: 30.153 },
      size: { w: 1.197, d: 1.029, h: 0.355 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.431,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-77",
      kind: "prop",
      label: "Tarp",
      position: { x: 10.831, z: 22.079 },
      size: { w: 1.408, d: 1.211, h: 0.418 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.688,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-78",
      kind: "prop",
      label: "Sandbags",
      position: { x: -8.256, z: 13.696 },
      size: { w: 1.976, d: 0.287, h: 0.269 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.909,
    },
    {
      id: "comm_tower_ridge-junk-79",
      kind: "prop",
      label: "Sandbags",
      position: { x: -32.862, z: 0.534 },
      size: { w: 1.739, d: 0.252, h: 0.237 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.565,
    },
    {
      id: "comm_tower_ridge-junk-81",
      kind: "prop",
      label: "Stump",
      position: { x: -22.271, z: 24.324 },
      size: { w: 0.84, d: 0.819, h: 0.92 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.046,
    },
    {
      id: "comm_tower_ridge-junk-82",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 20.524, z: -2.001 },
      size: { w: 2.344, d: 2.117, h: 0.993 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.655,
    },
    {
      id: "comm_tower_ridge-junk-83",
      kind: "prop",
      label: "Tarp",
      position: { x: -11.097, z: -25.618 },
      size: { w: 1.377, d: 1.184, h: 0.409 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.047,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-84",
      kind: "prop",
      label: "Tarp",
      position: { x: -14.614, z: -9.226 },
      size: { w: 1.52, d: 1.307, h: 0.451 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.379,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-85",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -21.97, z: -2.774 },
      size: { w: 2.381, d: 0.119, h: 2.274 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 1.099,
    },
    {
      id: "comm_tower_ridge-junk-86",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -12.654, z: -15.07 },
      size: { w: 2.583, d: 0.129, h: 2.467 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 4.61,
    },
    {
      id: "comm_tower_ridge-junk-87",
      kind: "prop",
      label: "Barrel",
      position: { x: -11.986, z: 9.832 },
      size: { w: 0.644, d: 0.644, h: 0.865 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.172,
    },
    {
      id: "comm_tower_ridge-junk-88",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -24.789, z: 1.144 },
      size: { w: 2.569, d: 0.128, h: 2.454 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 3.52,
    },
    {
      id: "comm_tower_ridge-junk-89",
      kind: "prop",
      label: "Stump",
      position: { x: -18.336, z: -1.636 },
      size: { w: 0.617, d: 0.601, h: 0.675 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.095,
    },
    {
      id: "comm_tower_ridge-junk-90",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 9.174, z: -27.055 },
      size: { w: 6.106, d: 2.413, h: 2.568 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      rotationY: 0.385,
    },
    {
      id: "comm_tower_ridge-junk-91",
      kind: "prop",
      label: "Tarp",
      position: { x: -17.409, z: 14.007 },
      size: { w: 1.624, d: 1.397, h: 0.482 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.566,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-92",
      kind: "prop",
      label: "Sandbags",
      position: { x: -7.879, z: 18.322 },
      size: { w: 1.646, d: 0.239, h: 0.224 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.849,
    },
    {
      id: "comm_tower_ridge-junk-93",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 25.758, z: -0.954 },
      size: { w: 1.921, d: 1.736, h: 0.814 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.833,
    },
    {
      id: "comm_tower_ridge-junk-94",
      kind: "prop",
      label: "Utility Post",
      position: { x: -21.318, z: -8.577 },
      size: { w: 1.489, d: 2.072, h: 4.324 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 5.328,
    },
    {
      id: "comm_tower_ridge-junk-95",
      kind: "prop",
      label: "Stump",
      position: { x: -28.584, z: 11.239 },
      size: { w: 0.617, d: 0.602, h: 0.675 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.485,
    },
    {
      id: "comm_tower_ridge-junk-96",
      kind: "prop",
      label: "Tarp",
      position: { x: 13.484, z: 12.534 },
      size: { w: 1.209, d: 1.04, h: 0.359 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.783,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-97",
      kind: "prop",
      label: "Tarp",
      position: { x: 26.143, z: 8.836 },
      size: { w: 1.316, d: 1.132, h: 0.391 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.051,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-98",
      kind: "prop",
      label: "Stump",
      position: { x: 29.063, z: -6.736 },
      size: { w: 0.859, d: 0.838, h: 0.941 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.046,
    },
    {
      id: "comm_tower_ridge-junk-99",
      kind: "prop",
      label: "Tarp",
      position: { x: 27.728, z: -11.545 },
      size: { w: 1.533, d: 1.319, h: 0.455 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.168,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-100",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 8.366, z: 19.918 },
      size: { w: 2.426, d: 2.192, h: 1.028 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.346,
    },
    {
      id: "comm_tower_ridge-junk-101",
      kind: "prop",
      label: "Stump",
      position: { x: -15.612, z: 9.837 },
      size: { w: 0.759, d: 0.74, h: 0.831 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.291,
    },
    {
      id: "comm_tower_ridge-junk-102",
      kind: "prop",
      label: "Sandbags",
      position: { x: 13.966, z: 20.085 },
      size: { w: 1.703, d: 0.247, h: 0.232 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.217,
    },
    {
      id: "comm_tower_ridge-junk-103",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -20.501, z: -12.153 },
      size: { w: 2.83, d: 0.141, h: 2.703 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 2.356,
    },
    {
      id: "comm_tower_ridge-junk-104",
      kind: "prop",
      label: "Barrel",
      position: { x: 11.238, z: 8.764 },
      size: { w: 0.6, d: 0.6, h: 0.806 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.223,
    },
    {
      id: "comm_tower_ridge-junk-105",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 5.325, z: 9.014 },
      size: { w: 2.349, d: 0.117, h: 2.244 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 5.511,
    },
    {
      id: "comm_tower_ridge-junk-106",
      kind: "prop",
      label: "Stump",
      position: { x: -19.968, z: 20.813 },
      size: { w: 0.832, d: 0.812, h: 0.911 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.326,
    },
    {
      id: "comm_tower_ridge-junk-107",
      kind: "prop",
      label: "Tarp",
      position: { x: -8.009, z: 21.166 },
      size: { w: 1.629, d: 1.401, h: 0.483 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.445,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-108",
      kind: "prop",
      label: "Barrel",
      position: { x: -3.754, z: 13.047 },
      size: { w: 0.795, d: 0.795, h: 1.067 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.175,
    },
    {
      id: "comm_tower_ridge-junk-109",
      kind: "prop",
      label: "Stump",
      position: { x: 16.021, z: -23.875 },
      size: { w: 0.822, d: 0.801, h: 0.9 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.45,
    },
    {
      id: "comm_tower_ridge-junk-110",
      kind: "prop",
      label: "Tarp",
      position: { x: -27.901, z: -17.259 },
      size: { w: 1.367, d: 1.176, h: 0.406 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.656,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-111",
      kind: "prop",
      label: "Tarp",
      position: { x: 14.493, z: 14.876 },
      size: { w: 1.264, d: 1.087, h: 0.375 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.04,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-112",
      kind: "prop",
      label: "Barrel",
      position: { x: 12.086, z: 11.448 },
      size: { w: 0.769, d: 0.769, h: 1.032 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.78,
    },
    {
      id: "comm_tower_ridge-junk-113",
      kind: "prop",
      label: "Stump",
      position: { x: 16.774, z: -2.835 },
      size: { w: 0.813, d: 0.793, h: 0.891 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.305,
    },
    {
      id: "comm_tower_ridge-junk-114",
      kind: "prop",
      label: "Tarp",
      position: { x: -10.876, z: -6.451 },
      size: { w: 1.165, d: 1.002, h: 0.346 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.345,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-115",
      kind: "prop",
      label: "Barrel",
      position: { x: -15.453, z: 16.043 },
      size: { w: 0.662, d: 0.662, h: 0.889 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.505,
    },
    {
      id: "comm_tower_ridge-junk-116",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 6.111, z: -19.444 },
      size: { w: 2.127, d: 1.921, h: 0.901 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.352,
    },
    {
      id: "comm_tower_ridge-junk-117",
      kind: "prop",
      label: "Barrel",
      position: { x: 11.154, z: -3.278 },
      size: { w: 0.61, d: 0.61, h: 0.819 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.502,
    },
    {
      id: "comm_tower_ridge-junk-118",
      kind: "prop",
      label: "Sandbags",
      position: { x: 31.86, z: 7.327 },
      size: { w: 1.661, d: 0.241, h: 0.226 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 5.113,
    },
    {
      id: "comm_tower_ridge-junk-119",
      kind: "prop",
      label: "Sandbags",
      position: { x: 16.776, z: -27.176 },
      size: { w: 1.673, d: 0.243, h: 0.228 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.462,
    },
    {
      id: "comm_tower_ridge-junk-120",
      kind: "prop",
      label: "Barrel",
      position: { x: 17.025, z: 6.54 },
      size: { w: 0.743, d: 0.743, h: 0.998 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.749,
    },
    {
      id: "comm_tower_ridge-junk-121",
      kind: "prop",
      label: "Barrel",
      position: { x: -24.245, z: 18.136 },
      size: { w: 0.813, d: 0.813, h: 1.092 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.35,
    },
    {
      id: "comm_tower_ridge-junk-122",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 20.941, z: 7.846 },
      size: { w: 0.708, d: 0.894, h: 1.018 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 3.54,
    },
    {
      id: "comm_tower_ridge-junk-124",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -15.984, z: -11.564 },
      size: { w: 0.694, d: 0.876, h: 0.997 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 4.205,
    },
    {
      id: "comm_tower_ridge-junk-125",
      kind: "prop",
      label: "Sandbags",
      position: { x: 18.164, z: -5.205 },
      size: { w: 1.623, d: 0.235, h: 0.221 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.373,
    },
    {
      id: "comm_tower_ridge-junk-126",
      kind: "prop",
      label: "Barrel",
      position: { x: -26.367, z: -18.395 },
      size: { w: 0.623, d: 0.623, h: 0.837 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.179,
    },
    {
      id: "comm_tower_ridge-junk-127",
      kind: "prop",
      label: "Stump",
      position: { x: -0.954, z: 20.559 },
      size: { w: 0.834, d: 0.814, h: 0.914 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.176,
    },
    {
      id: "comm_tower_ridge-junk-128",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -5.633, z: 15.461 },
      size: { w: 0.783, d: 0.988, h: 1.124 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.072,
    },
    {
      id: "comm_tower_ridge-junk-129",
      kind: "prop",
      label: "Barrel",
      position: { x: -4.351, z: -7.852 },
      size: { w: 0.703, d: 0.703, h: 0.944 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.439,
    },
    {
      id: "comm_tower_ridge-junk-130",
      kind: "prop",
      label: "Tarp",
      position: { x: -18.74, z: 21.978 },
      size: { w: 1.482, d: 1.275, h: 0.44 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.594,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-131",
      kind: "prop",
      label: "Utility Post",
      position: { x: 18.989, z: -25.894 },
      size: { w: 1.247, d: 1.735, h: 3.621 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 3.235,
    },
    {
      id: "comm_tower_ridge-junk-132",
      kind: "prop",
      label: "Stump",
      position: { x: -15.323, z: -18.871 },
      size: { w: 0.677, d: 0.661, h: 0.742 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.477,
    },
    {
      id: "comm_tower_ridge-junk-133",
      kind: "prop",
      label: "Sandbags",
      position: { x: 21.58, z: -4.466 },
      size: { w: 1.667, d: 0.242, h: 0.227 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 6.228,
    },
    {
      id: "comm_tower_ridge-junk-134",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 24.048, z: -14.084 },
      size: { w: 5.284, d: 3.136, h: 3.198 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 4.3,
    },
    {
      id: "comm_tower_ridge-junk-135",
      kind: "prop",
      label: "Barrel",
      position: { x: 2.807, z: -18.394 },
      size: { w: 0.785, d: 0.785, h: 1.053 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.816,
    },
    {
      id: "comm_tower_ridge-junk-136",
      kind: "prop",
      label: "Stump",
      position: { x: 9.893, z: 24.674 },
      size: { w: 0.782, d: 0.763, h: 0.856 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.866,
    },
    {
      id: "comm_tower_ridge-junk-137",
      kind: "prop",
      label: "Sandbags",
      position: { x: 1.46, z: -21.568 },
      size: { w: 1.684, d: 0.244, h: 0.23 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 6.103,
    },
    {
      id: "comm_tower_ridge-junk-138",
      kind: "prop",
      label: "Utility Post",
      position: { x: 12.19, z: 13.592 },
      size: { w: 1.227, d: 1.707, h: 3.562 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 0.649,
    },
    {
      id: "comm_tower_ridge-junk-139",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -12.497, z: 19.342 },
      size: { w: 2.335, d: 0.117, h: 2.23 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 0.91,
    },
    {
      id: "comm_tower_ridge-junk-140",
      kind: "prop",
      label: "Tarp",
      position: { x: 12.779, z: -23.929 },
      size: { w: 1.341, d: 1.153, h: 0.398 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.772,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-141",
      kind: "prop",
      label: "Sandbags",
      position: { x: 28.204, z: -4.546 },
      size: { w: 1.874, d: 0.272, h: 0.255 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.506,
    },
    {
      id: "comm_tower_ridge-junk-142",
      kind: "prop",
      label: "Barrel",
      position: { x: 14.818, z: 24.04 },
      size: { w: 0.784, d: 0.784, h: 1.053 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.788,
    },
    {
      id: "comm_tower_ridge-junk-143",
      kind: "prop",
      label: "Barrel",
      position: { x: 14.485, z: -17.734 },
      size: { w: 0.616, d: 0.616, h: 0.827 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.002,
    },
    {
      id: "comm_tower_ridge-junk-144",
      kind: "prop",
      label: "Stump",
      position: { x: -16.071, z: 14.813 },
      size: { w: 0.782, d: 0.763, h: 0.856 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.06,
    },
    {
      id: "comm_tower_ridge-junk-146",
      kind: "prop",
      label: "Utility Post",
      position: { x: -10.735, z: 14.296 },
      size: { w: 1.266, d: 1.761, h: 3.676 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 0.474,
    },
    {
      id: "comm_tower_ridge-junk-147",
      kind: "prop",
      label: "Utility Post",
      position: { x: 6.332, z: -3.761 },
      size: { w: 1.449, d: 2.016, h: 4.208 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 3.683,
    },
    {
      id: "comm_tower_ridge-junk-148",
      kind: "prop",
      label: "Sandbags",
      position: { x: 7.792, z: 8.466 },
      size: { w: 2.104, d: 0.305, h: 0.287 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.473,
    },
    {
      id: "comm_tower_ridge-junk-149",
      kind: "prop",
      label: "Tarp",
      position: { x: -7.719, z: -3.193 },
      size: { w: 1.315, d: 1.131, h: 0.39 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.94,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-150",
      kind: "prop",
      label: "Stump",
      position: { x: 19.433, z: 12.687 },
      size: { w: 0.785, d: 0.766, h: 0.86 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.317,
    },
    {
      id: "comm_tower_ridge-junk-151",
      kind: "prop",
      label: "Tarp",
      position: { x: 27.742, z: -0.965 },
      size: { w: 1.613, d: 1.387, h: 0.479 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.468,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-152",
      kind: "prop",
      label: "Sandbags",
      position: { x: -26.054, z: -0.825 },
      size: { w: 1.73, d: 0.251, h: 0.236 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.819,
    },
    {
      id: "comm_tower_ridge-junk-153",
      kind: "prop",
      label: "Stump",
      position: { x: -25.35, z: -15.257 },
      size: { w: 0.71, d: 0.693, h: 0.778 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.59,
    },
    {
      id: "comm_tower_ridge-junk-155",
      kind: "prop",
      label: "Barrel",
      position: { x: -28.999, z: 4.041 },
      size: { w: 0.59, d: 0.59, h: 0.792 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.057,
    },
    {
      id: "comm_tower_ridge-junk-156",
      kind: "prop",
      label: "Barrel",
      position: { x: 3.738, z: -5.941 },
      size: { w: 0.814, d: 0.814, h: 1.092 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.793,
    },
    {
      id: "comm_tower_ridge-junk-157",
      kind: "prop",
      label: "Tarp",
      position: { x: -13.34, z: -18.05 },
      size: { w: 1.171, d: 1.007, h: 0.348 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.462,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-158",
      kind: "prop",
      label: "Barrel",
      position: { x: -22.277, z: -17.33 },
      size: { w: 0.732, d: 0.732, h: 0.983 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.449,
    },
    {
      id: "comm_tower_ridge-junk-159",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 17.216, z: -16.732 },
      size: { w: 2.015, d: 1.82, h: 0.853 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.13,
    },
    {
      id: "comm_tower_ridge-junk-160",
      kind: "prop",
      label: "Stump",
      position: { x: -27.091, z: -12.932 },
      size: { w: 0.687, d: 0.67, h: 0.753 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 6.085,
    },
    {
      id: "comm_tower_ridge-junk-161",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -16.105, z: 12.477 },
      size: { w: 0.792, d: 1, h: 1.138 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.009,
    },
    {
      id: "comm_tower_ridge-junk-162",
      kind: "prop",
      label: "Barrel",
      position: { x: -10.982, z: -20.746 },
      size: { w: 0.763, d: 0.763, h: 1.024 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.658,
    },
    {
      id: "comm_tower_ridge-junk-163",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 11.289, z: -21.735 },
      size: { w: 2.454, d: 2.217, h: 1.039 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.755,
    },
    {
      id: "comm_tower_ridge-junk-164",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 5.719, z: 13.29 },
      size: { w: 2.345, d: 2.118, h: 0.993 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.506,
    },
    {
      id: "comm_tower_ridge-junk-165",
      kind: "prop",
      label: "Stump",
      position: { x: 5.76, z: -14.705 },
      size: { w: 0.723, d: 0.706, h: 0.792 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.026,
    },
    {
      id: "comm_tower_ridge-junk-166",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -19.609, z: 15.337 },
      size: { w: 2.46, d: 0.123, h: 2.35 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 2.988,
    },
    {
      id: "comm_tower_ridge-junk-167",
      kind: "prop",
      label: "Sandbags",
      position: { x: 10.272, z: -19.398 },
      size: { w: 1.971, d: 0.286, h: 0.269 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.282,
    },
    {
      id: "comm_tower_ridge-junk-168",
      kind: "prop",
      label: "Sandbags",
      position: { x: -9.504, z: -11.397 },
      size: { w: 1.825, d: 0.265, h: 0.249 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.201,
    },
    {
      id: "comm_tower_ridge-junk-169",
      kind: "prop",
      label: "Barrel",
      position: { x: -20.751, z: 25.193 },
      size: { w: 0.736, d: 0.736, h: 0.988 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.107,
    },
    {
      id: "comm_tower_ridge-junk-171",
      kind: "prop",
      label: "Stump",
      position: { x: 23.336, z: -5.797 },
      size: { w: 0.854, d: 0.833, h: 0.936 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.969,
    },
    {
      id: "comm_tower_ridge-junk-172",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -17.773, z: 1.443 },
      size: { w: 0.63, d: 0.796, h: 0.905 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 3.6,
    },
    {
      id: "comm_tower_ridge-junk-174",
      kind: "prop",
      label: "Utility Post",
      position: { x: -25.127, z: 19.718 },
      size: { w: 1.488, d: 2.07, h: 4.32 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 4.82,
    },
    {
      id: "comm_tower_ridge-junk-175",
      kind: "prop",
      label: "Stump",
      position: { x: -13.329, z: -24.223 },
      size: { w: 0.856, d: 0.835, h: 0.937 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.656,
    },
    {
      id: "comm_tower_ridge-junk-176",
      kind: "prop",
      label: "Sandbags",
      position: { x: 24.481, z: 20.755 },
      size: { w: 1.526, d: 0.221, h: 0.208 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.213,
    },
    {
      id: "comm_tower_ridge-junk-177",
      kind: "prop",
      label: "Tarp",
      position: { x: 16.012, z: -7.969 },
      size: { w: 1.262, d: 1.086, h: 0.375 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.929,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-178",
      kind: "prop",
      label: "Stump",
      position: { x: -4.304, z: 21.418 },
      size: { w: 0.754, d: 0.736, h: 0.826 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.106,
    },
    {
      id: "comm_tower_ridge-junk-179",
      kind: "prop",
      label: "Tarp",
      position: { x: 7.621, z: -2.093 },
      size: { w: 1.598, d: 1.375, h: 0.474 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 6.013,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "comm_tower_ridge-junk-180",
      kind: "prop",
      label: "Barrel",
      position: { x: -12.786, z: 29.862 },
      size: { w: 0.781, d: 0.781, h: 1.048 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.713,
    },
    {
      id: "comm_tower_ridge-junk-181",
      kind: "prop",
      label: "Barrel",
      position: { x: 13.424, z: -11.998 },
      size: { w: 0.763, d: 0.763, h: 1.024 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.339,
    },
    {
      id: "comm_tower_ridge-junk-182",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 0.776, z: -26.695 },
      size: { w: 0.81, d: 1.023, h: 1.164 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 4.278,
    },
    {
      id: "comm_tower_ridge-junk-183",
      kind: "prop",
      label: "Barrel",
      position: { x: 8.55, z: -23.119 },
      size: { w: 0.61, d: 0.61, h: 0.819 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.934,
    },
    {
      id: "comm_tower_ridge-junk-184",
      kind: "prop",
      label: "Stump",
      position: { x: -18.429, z: -0.626 },
      size: { w: 0.705, d: 0.687, h: 0.772 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.717,
    },
    {
      id: "comm_tower_ridge-junk-185",
      kind: "prop",
      label: "Barrel",
      position: { x: 4.09, z: -22.416 },
      size: { w: 0.746, d: 0.746, h: 1.001 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.784,
    },
    {
      id: "comm_tower_ridge-junk-186",
      kind: "prop",
      label: "Barrel",
      position: { x: -8.254, z: -4.559 },
      size: { w: 0.804, d: 0.804, h: 1.079 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.204,
    },
    {
      id: "comm_tower_ridge-junk-187",
      kind: "prop",
      label: "Stump",
      position: { x: -20.438, z: -22.102 },
      size: { w: 0.599, d: 0.585, h: 0.656 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.471,
    },
    {
      id: "comm_tower_ridge-junk-188",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 11.504, z: 28.273 },
      size: { w: 0.796, d: 1.006, h: 1.144 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.464,
    },
    {
      id: "comm_tower_ridge-junk-189",
      kind: "prop",
      label: "Stump",
      position: { x: -26.015, z: -2.981 },
      size: { w: 0.783, d: 0.764, h: 0.857 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.196,
    },
    {
      id: "comm_tower_ridge-junk-190",
      kind: "prop",
      label: "Stump",
      position: { x: 4.474, z: -13.709 },
      size: { w: 0.767, d: 0.748, h: 0.84 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.934,
    },
    {
      id: "comm_tower_ridge-junk-191",
      kind: "prop",
      label: "Barrel",
      position: { x: 4.702, z: -10.285 },
      size: { w: 0.639, d: 0.639, h: 0.858 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.86,
    },
    {
      id: "comm_tower_ridge-junk-192",
      kind: "prop",
      label: "Sandbags",
      position: { x: 29.961, z: 7.93 },
      size: { w: 1.834, d: 0.266, h: 0.25 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.758,
    },
    {
      id: "comm_tower_ridge-junk-194",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -14.857, z: -22.466 },
      size: { w: 2.416, d: 0.121, h: 2.308 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 2.851,
    },
    {
      id: "comm_tower_ridge-junk-195",
      kind: "prop",
      label: "Barrel",
      position: { x: -7.477, z: -17.598 },
      size: { w: 0.803, d: 0.803, h: 1.078 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.785,
    },
    {
      id: "comm_tower_ridge-junk-196",
      kind: "prop",
      label: "Stump",
      position: { x: -13.765, z: -25.349 },
      size: { w: 0.79, d: 0.771, h: 0.865 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.98,
    },
    {
      id: "comm_tower_ridge-junk-197",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -29.463, z: 12.344 },
      size: { w: 0.697, d: 0.88, h: 1.001 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 4.542,
    },
    {
      id: "comm_tower_ridge-junk-198",
      kind: "prop",
      label: "Barrel",
      position: { x: 16.99, z: -20.77 },
      size: { w: 0.611, d: 0.611, h: 0.82 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.67,
    },
    {
      id: "comm_tower_ridge-junk-199",
      kind: "prop",
      label: "Barrel",
      position: { x: 13.623, z: -8.448 },
      size: { w: 0.783, d: 0.783, h: 1.051 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.729,
    },
    {
      id: "comm_tower_ridge-junk-200",
      kind: "prop",
      label: "Barrel",
      position: { x: 7.648, z: 28.527 },
      size: { w: 0.7, d: 0.7, h: 0.939 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.232,
    },
    {
      id: "comm_tower_ridge-junk-201",
      kind: "prop",
      label: "Stump",
      position: { x: -28.356, z: -12.772 },
      size: { w: 0.839, d: 0.819, h: 0.919 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.561,
    },
    {
      id: "comm_tower_ridge-junk-202",
      kind: "prop",
      label: "Barrel",
      position: { x: 31.585, z: -3.946 },
      size: { w: 0.77, d: 0.77, h: 1.034 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.635,
    },
    {
      id: "comm_tower_ridge-junk-203",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 12.719, z: -4.628 },
      size: { w: 2.265, d: 2.046, h: 0.959 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.702,
    },
    {
      id: "comm_tower_ridge-junk-204",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -2.139, z: 27.086 },
      size: { w: 2.433, d: 0.122, h: 2.324 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 5.022,
    },
    {
      id: "comm_tower_ridge-junk-205",
      kind: "prop",
      label: "Barrel",
      position: { x: -16.286, z: -9.832 },
      size: { w: 0.669, d: 0.669, h: 0.898 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.731,
    },
  ],

  collisionZones: [
    {
      id: "edge-n",
      label: "Ridge",
      position: { x: 0, z: -39 },
      size: { w: 76, d: 2 },
    },
    {
      id: "edge-s",
      label: "Ridge",
      position: { x: 0, z: 39 },
      size: { w: 76, d: 2 },
    },
    {
      id: "edge-w",
      label: "Ridge",
      position: { x: -37, z: 0 },
      size: { w: 2, d: 80 },
    },
    {
      id: "edge-e",
      label: "Ridge",
      position: { x: 37, z: 0 },
      size: { w: 2, d: 80 },
    },
    {
      id: "fog-1",
      label: "Low Fog",
      position: { x: -16.77, z: -6.17 },
      size: { w: 19.850972414016724, d: 16.421106964349747 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 9410208, opacity: 0.38, height: 3.6 },
    },
    {
      id: "fog-2",
      label: "Low Fog",
      position: { x: 25.8, z: -9.89 },
      size: { w: 15.587029214948416, d: 16.96690841577947 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 9410208, opacity: 0.38, height: 3.6 },
    },
    {
      id: "fog-3",
      label: "Low Fog",
      position: { x: 20.7, z: 15.47 },
      size: { w: 16.114990102127194, d: 13.06477583758533 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 9410208, opacity: 0.38, height: 3.6 },
    },
  ],

  roads: [
    {
      id: "ct-access",
      label: "Access Road",
      surface: "dirt_road",
      points: [{ x: 4, z: 34 }, { x: -4, z: -32 }],
      width: 4.264,
      opacity: 0.6,
    },
    {
      id: "ct-ridge",
      label: "Ridge Path",
      surface: "dirt_path",
      points: [{ x: -32, z: 8 }, { x: 32, z: 2 }],
      width: 3.936,
      opacity: 0.6,
    },
  ],

  npcs: {
  },

  dialog: {
  },
};
